import {
	BranchFilterSession,
	EMPTY_BRANCH_FILTER_SESSION,
	normalizeBranchFilter,
} from '@/pages/User/pages/Branches/branchFilterUi'
import {
	BranchTreeBySystem,
	normalizeBranchTreeBySystem,
} from '@/pages/User/pages/Branches/branchTree'
import {
	EMPTY_STRUCTURE_SEARCH_SESSION,
	normalizeSearchState,
	StructureSearchSession,
} from '@/pages/User/pages/Home/components/StructureSearchPanel/searchPanelUi'

import { Actions } from './actions'
import {
	UPDATE_BRANCH_FILTER,
	UPDATE_BRANCH_TREE,
	UPDATE_SETTINGS,
	UPDATE_STRUCTURE_SEARCH,
} from './constants'

export type State = Readonly<typeof initialState>
export type SettingsSession = State

export const getSettingsSession = (state: State) => ({
	...state,
})

const initialState = {
	userInterface: {
		scriptEditor: {
			autocompleteKeywords: true,
			autocompleteSnippets: true,
			autocompleteElements: true,
		},
	},
	structureSearch: EMPTY_STRUCTURE_SEARCH_SESSION as StructureSearchSession,
	branchFilter: EMPTY_BRANCH_FILTER_SESSION as BranchFilterSession,
	branchTreeBySystem: {} as BranchTreeBySystem,
}

const normalizeStructureSearch = (
	value: Partial<StructureSearchSession> | undefined,
	fallback: StructureSearchSession = EMPTY_STRUCTURE_SEARCH_SESSION,
): StructureSearchSession => ({
	q: typeof value?.q === 'string' ? value.q : fallback.q,
	types: Array.isArray(value?.types) ? value.types : fallback.types,
	saved: Array.isArray(value?.saved) ? value.saved : fallback.saved,
	scope: {
		...EMPTY_STRUCTURE_SEARCH_SESSION.scope,
		...fallback.scope,
		...value?.scope,
		state: normalizeSearchState(
			value?.scope?.state ?? fallback.scope.state,
		),
	},
})

export default (state = initialState, action: Actions): State => {
	switch (action.type) {
		case UPDATE_SETTINGS: {
			return {
				...state,
				...action.payload,
				structureSearch: normalizeStructureSearch(
					action.payload.structureSearch,
					state.structureSearch,
				),
				branchFilter: normalizeBranchFilter(
					action.payload.branchFilter,
					state.branchFilter,
				),
				branchTreeBySystem: normalizeBranchTreeBySystem(
					action.payload.branchTreeBySystem,
					state.branchTreeBySystem,
				),
				userInterface: {
					...state.userInterface,
					...action.payload.userInterface,
					scriptEditor: {
						...state.userInterface.scriptEditor,
						...action.payload.userInterface?.scriptEditor,
					},
				},
			}
		}

		case UPDATE_STRUCTURE_SEARCH: {
			return {
				...state,
				structureSearch: normalizeStructureSearch(
					{ ...state.structureSearch, ...action.payload },
					state.structureSearch,
				),
			}
		}

		case UPDATE_BRANCH_FILTER: {
			return {
				...state,
				branchFilter: normalizeBranchFilter(
					{ ...state.branchFilter, ...action.payload },
					state.branchFilter,
				),
			}
		}

		case UPDATE_BRANCH_TREE: {
			const session = normalizeBranchTreeBySystem({
				[action.systemId]: action.session,
			})[action.systemId]
			if (!session) return state
			return {
				...state,
				branchTreeBySystem: {
					...state.branchTreeBySystem,
					[action.systemId]: session,
				},
			}
		}

		default: {
			return state
		}
	}
}
